import classnames from 'classnames';
import {formatPaymentMethod} from '../utils';
import {useProcessFastlanePaymentToken, useManageFastlanePaymentToken} from "../hooks";
import {usePaymentMethodDataContext} from "../context";

export default function TokenizedCard(
    {
        data,
        token,
        fastlane,
        customerFound,
        ...props
    }) {
    const {
        onPaymentDataFilter
    } = usePaymentMethodDataContext();

    const {
        i18n,
        fastlane_icons,
        payment_format
    } = data;

    const {
        emitResponse,
        shouldSavePayment
    } = props;

    const {
        responseTypes
    } = emitResponse;

    let {
        card
    } = token.paymentSource;

    card = {
        ...card,
        brand: card.brand,
        last4: card.lastDigits,
        expiry: card.expiry
    };

    useProcessFastlanePaymentToken({
        token,
        responseTypes,
        shouldSavePayment,
        onPaymentDataFilter
    });

    const {
        onCancel,
        onChangePaymentMethod
    } = useManageFastlanePaymentToken({
        fastlane
    });

    return (
        <div className={classnames('wc-ppcp-tokenized-card', {'has-customer-context': customerFound})}>
            <CardIcon icons={fastlane_icons} brand={card.brand.toLowerCase()}/>
            <div className="wc-ppcp-tokenized-card-format">
                {formatPaymentMethod(payment_format, card)}
            </div>
            <div className="wc-ppcp-tokenized-card-actions">
                <a
                    className="wc-ppcp-tokenized-card-cancel"
                    onClick={onCancel}>
                    {i18n.cancel}
                </a>
                {customerFound &&
                    <a
                        className="wc-ppcp-tokenized-card-change"
                        onClick={onChangePaymentMethod}>
                        {i18n.change}
                    </a>
                }
            </div>
        </div>
    )
}

const CardIcon = ({icons, brand}) => {
    let src = '';

    if (icons[brand]) {
        src = icons[brand];
    }

    return (
        <div className="wc-ppcp-tokenized-card-icon-container">
            <img src={src}/>
        </div>
    )
}